<script>
import ItemComponent from '../Item/component.vue';

export default {
  components: {
    ItemComponent,
  },
  props: {
    module: Object,
  },
};
</script>
<template>
  <FBody
    v-if="module"
    :module="module"
    fixed-label
  >
    <RowSpan>
      <ColSpan span="6">
        <FItem
          :module="module.getItem('tourist')"
        />
      </ColSpan>
      <ColSpan span="3">
        <FItem
          :module="module.getItem('email')"
        />
      </ColSpan>
      <ColSpan span="3">
        <FItem
          :module="module.getItem('phone')"
        />
      </ColSpan>
    </RowSpan>
    <ItemComponent
      v-if="module.tourist.value && !module.tourist.value.value"
      :module="module"
    />
  </FBody>
</template>
<style lang="scss">

</style>
